var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 72,
      height: 60
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26086 19.3477L3.2826 3.85153H0V0.608643H9.23912V3.85153H6.84782L10.8043 14.3855L14.7826 3.85153H12.2391V0.608643H21.2174V3.85153H18.3913L12.5217 19.3477H9.26086Z",
    fill: "#b2b2b2",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4348 16.6054C18.4348 15.8437 18.6957 15.1907 19.2392 14.6466C19.7826 14.1025 20.4348 13.8196 21.2174 13.8196C21.9783 13.8196 22.6305 14.1025 23.1739 14.6466C23.7174 15.1907 24 15.8437 24 16.6054C24 17.3672 23.7174 18.0419 23.1739 18.586C22.6305 19.1301 21.9783 19.3912 21.2174 19.3912C20.4565 19.3912 19.7826 19.1301 19.2392 18.586C18.7174 18.0419 18.4348 17.3889 18.4348 16.6054Z",
    fill: "#b2b2b2",
    fillOpacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignLogo);
export default __webpack_public_path__ + "static/media/sign-logo.a34cb5ee5870c79266f8fd405cc2bcd5.svg";
export { ForwardRef as ReactComponent };